jQuery(document).ajaxComplete(function(event, xhr, settings) {
  console.log('AJAX call finished:', settings.url);
 // setTimeout(function(){
    jQuery('.cart__checkout-button').removeClass('disabled');
    jQuery('.cart__checkout-button').removeAttr('disabled');

    jQuery('#standard-shipping-option-div').on('click',function(){
     jQuery('.sherpa-checkpostcode')[0].style.setProperty('display', 'block', 'important'); // Add !important
    });
    jQuery('#pickup-option-div').on('click',function(){
      jQuery('.sherpa-checkpostcode')[0].style.setProperty('display', 'none', 'important');
    });
 // },500);  
});

// jQuery(document).on("click",".template-Product .addToCart", function (e) {
//   var cartProduct = jQuery("#productCart").val();
//   var requireShipping = jQuery("#requireShipping").val();
//   if (cartProduct == 2) {
//   } else {
//     if (cartProduct != requireShipping) {
//       if (requireShipping) {
//         jQuery("#pickupDialogBox").show();
//         jQuery("body").addClass("popopNoScroll");
//         jQuery("#pickupClosePopup").click(function () {
//           jQuery("#pickupDialogBox").hide();
//           jQuery("body").removeClass("popopNoScroll");
//         });
//       } else {
//         jQuery("#shippingDialogBox").show();
//         jQuery("body").addClass("popopNoScroll");
//         jQuery("#shipClosePopup").click(function () {
//           jQuery("#shippingDialogBox").hide();
//           jQuery("body").removeClass("popopNoScroll");
//         });
//       }
//       e.preventDefault();
//     }
//   }
// });
jQuery(document).ready(function ($) {


  // $(".template-PageMothersDayExperience #form-date").datepicker({
  //   beforeShowDay: function(date) {
  //     // Only allow May (Month = 4 since January is 0)
  //     return [date.getMonth() === 4, ""];
  //   },
  //   onChangeMonthYear: function(year, month, inst) {
  //     // Automatically switch to May if user changes the month
  //     if (month !== 5) {
  //       $(this).datepicker("setDate", new Date(year, 4, 1));
  //     }
  //   },
  //   defaultDate: new Date(new Date().getFullYear(), 4, 1), // default to May 1
  //   changeMonth: false, // prevent month change
  //   changeYear: true
  // });


// Check if popup has been shown before
// if (!localStorage.getItem('popupShown')) {
//   $('html').addClass('popup-open');
//   localStorage.setItem('popupShown', 'true');
// }
// // Close popup on click
// $('.close-popup').click(function(e) {
//   if (e.target === this) {
//     $('html').removeClass('popup-open');
//   }
// });

$(document).on('mousedown', function (e) {
  var $datepicker = $('.ui-datepicker');
  if (
    $datepicker.is(':visible') &&
    !$(e.target).closest('.ui-datepicker, .hasDatepicker').length
  ) {
    $('.hasDatepicker').datepicker('hide');
  }
});

 setTimeout(function(){
   jQuery('.template-Product .expo-element-label').addClass('input-focus');
   jQuery('.template-Product .expo-element-label').addClass('value-focus');
 },700);
  
  console.log("thats it...");
 var pickup_popup_get =  localStorage.getItem('pickup_popup'); 
  
  setTimeout(function() {
    if(pickup_popup_get != 'true')
     {
      // $(".custom_show_popup").fadeIn(500);
     }
  }, 500);
   
//   $(".custom_show_popup .close").click(function() {
//   $(".custom_show_popup").fadeOut(500);
// });
setTimeout(function() {  
  localStorage.setItem('pickup_popup', 'true'); 
}, 550);   
  setTimeout(function () {
    if (jQuery("html").hasClass("bundle-2")) {
      jQuery(".gbbPageBody").removeClass("gbbProductsCardLayoutV2");
    }
  }, 100);

  jQuery("#form-date").on("keydown", function (event) {
    event.preventDefault(); // This line prevents all key inputs
  });

  jQuery.getJSON("/cart.js", function (cart) {
    cart.items.forEach(function (item) {
      //console.log("Test", item);

      if (item.requires_shipping) {
        //alert(item.title + " needs to be shipped.");
        jQuery("#productCart").val("1");
      } else {
        //alert(item.title + " does not need to be shipped.");
        jQuery("#productCart").val("");
      }
    });
  });

  //JS for product detal page date picker for booking product date after 3days or 5days
  jQuery(".product__pickup-availabilities").hide();
  var currentYear = new Date().getFullYear();
  const lastDayOfYear = new Date(currentYear, 11, 31);
  var disabledDates = [];
  var dateInput = jQuery(
    "#expo-option-b9e4c76a-4c56-4a49-a0d5-843898d0d1a4,#expo-option-2d490f2f-7f45-49b2-9060-2c3a7ce47311, #expo-option-2c0cae5f-d6b8-4fec-b4e2-eba8cabacb8f, #expo-option-5141ea06-d3f8-4efa-b36c-8ce964033d46"
  );
  dateInput.datepicker({
    minDate: new Date(new Date().setDate(new Date().getDate() + 5)),
    dateFormat: "yy-mm-dd",
  });
  if (
    jQuery("body").hasClass("GelatoCake") ||
    jQuery("body").hasClass("100GiftVoucher") ||
    jQuery("body").hasClass("SplitEggWith7Chocolates") ||
    jQuery("body").hasClass("template-Product")
  ) {
    function getDisabledMondays(year) {
      var disabledMondays = [];
      var currentDate = new Date(year, 0, 1); // January 1st of the given year
      // Iterate through all the days of the year
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Monday (Monday corresponds to day 1)
        if (currentDate.getDay() === 2) {
          // Format the date as "YYYY-MM-DD" and add it to the array
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledMondays.push(formattedDate);
        }
        // Move to the next day
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledMondays;
    }

    function getDisabledSundays(year) {
      var disabledSundays = [];
      var currentDate = new Date(year, 0, 1);
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Sunday (Sunday corresponds to day 0)
        if (currentDate.getDay() === 1) {
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledSundays.push(formattedDate);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledSundays;
    }

    function getDisabledWeekends(year) {
      var disabledWeekends = [];
      var currentDate = new Date(year, 0, 1);
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Saturday (Saturday corresponds to day 0) or Sunday (Sunday corresponds to day 1)
        if (currentDate.getDay() === 0 || currentDate.getDay() === 1) {
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledWeekends.push(formattedDate);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledWeekends;
    }

    function updateDatepicker() {
      dateInput.datepicker("destroy"); // Destroy the existing Datepicker instance
      dateInput.datepicker({
        beforeShowDay: function (date) {
          var string = $.datepicker.formatDate("yy-mm-dd", date);
          return [disabledDates.indexOf(string) == -1];
        },
      });

      dateInput.datepicker("option", {
        minDate: new Date(new Date().setDate(new Date().getDate() + 5)),
        dateFormat: "yy-mm-dd",
      });
    }

    jQuery(
      "#expo-option-6133282e-377f-4296-8aa2-d591b1651fb1 , #expo-option-029f6ebb-988f-49d6-abf6-a3584d6210a6, #expo-option-5141ea06-d3f8-4efa-b36c-8ce964033d46"
    ).on("change", function () {
      var selectedValue = jQuery(this).val();
      console.log(selectedValue);
      // Update the disabledDates array based on the selected value
      if (selectedValue === "Newtown (Closed Monday)") {
        disabledDates = getDisabledMondays(currentYear);
      } else if (selectedValue === "Parramatta (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (selectedValue === "Sydney City (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (selectedValue === "Wynyard (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (
        selectedValue === "Quay Quarter Lanes (Closed Saturday & Sunday)"
      ) {
        disabledDates = getDisabledWeekends(currentYear);
      } else {
        disabledDates = [];
      }
      // Reinitialize the Datepicker with the updated dates
      updateDatepicker();
    });
  } else if (
    jQuery("body").hasClass("LargeChocolateBasket25Chocolates") ||
    jQuery("body").hasClass("TallChocolateBasket12Chocolates") ||
    jQuery("body").hasClass("template-Product")
  ) {
    var currentYear = new Date().getFullYear();
    const lastDayOfYear = new Date(currentYear, 11, 31);
    var disabledDates = [];
    var dateInput = jQuery(
      "#expo-option-2c0cae5f-d6b8-4fec-b4e2-eba8cabacb8f , #expo-option-2d490f2f-7f45-49b2-9060-2c3a7ce47311, #expo-option-5141ea06-d3f8-4efa-b36c-8ce964033d46"
    );
    dateInput.datepicker({
      minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
      dateFormat: "yy-mm-dd",
    });

    function getDisabledMondays(year) {
      var disabledMondays = [];
      var currentDate = new Date(year, 0, 1); // January 1st of the given year
      // Iterate through all the days of the year
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Monday (Monday corresponds to day 1)
        if (currentDate.getDay() === 2) {
          // Format the date as "YYYY-MM-DD" and add it to the array
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledMondays.push(formattedDate);
        }
        // Move to the next day
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledMondays;
    }

    function getDisabledSundays(year) {
      var disabledSundays = [];
      var currentDate = new Date(year, 0, 1);
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Sunday (Sunday corresponds to day 0)
        if (currentDate.getDay() === 1) {
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledSundays.push(formattedDate);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledSundays;
    }

    function getDisabledWeekends(year) {
      var disabledWeekends = [];
      var currentDate = new Date(year, 0, 1);
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Saturday (Saturday corresponds to day 0) or Sunday (Sunday corresponds to day 1)
        if (currentDate.getDay() === 0 || currentDate.getDay() === 1) {
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledWeekends.push(formattedDate);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledWeekends;
    }

    function updateDatepicker() {
      dateInput.datepicker("destroy"); // Destroy the existing Datepicker instance
      dateInput.datepicker({
        beforeShowDay: function (date) {
          var string = $.datepicker.formatDate("yy-mm-dd", date);
          return [disabledDates.indexOf(string) == -1];
        },
      });

      dateInput.datepicker("option", {
        minDate: new Date(new Date().setDate(new Date().getDate() + 5)),
        dateFormat: "yy-mm-dd",
      });
    }

    jQuery(
      "#expo-option-6133282e-377f-4296-8aa2-d591b1651fb1 , #expo-option-2d490f2f-7f45-49b2-9060-2c3a7ce47311, #expo-option-5141ea06-d3f8-4efa-b36c-8ce964033d46"
    ).on("change", function () {
      var selectedValue = jQuery(this).val();
      // Update the disabledDates array based on the selected value
      if (selectedValue === "Newtown (Closed Monday)") {
        disabledDates = getDisabledMondays(currentYear);
      } else if (selectedValue === "Parramatta (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (selectedValue === "Sydney City (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (selectedValue === "Wynyard (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (
        selectedValue === "Quay Quarter Lanes (Closed Saturday & Sunday)"
      ) {
        disabledDates = getDisabledWeekends(currentYear);
      } else {
        disabledDates = [];
      }
      // Reinitialize the Datepicker with the updated dates
      updateDatepicker();
    });
  } else {
    var currentYear = new Date().getFullYear();
    const lastDayOfYear = new Date(currentYear, 11, 31);
    var disabledDates = [];
    var dateInput = jQuery(
      "#expo-option-2c0cae5f-d6b8-4fec-b4e2-eba8cabacb8f, #expo-option-5141ea06-d3f8-4efa-b36c-8ce964033d46"
    );
    dateInput.datepicker({
      minDate: new Date(new Date().setDate(new Date().getDate() + 3)),
      dateFormat: "yy-mm-dd",
    });

    function getDisabledMondays(year) {
      var disabledMondays = [];
      var currentDate = new Date(year, 0, 1); // January 1st of the given year
      // Iterate through all the days of the year
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Monday (Monday corresponds to day 1)
        if (currentDate.getDay() === 2) {
          // Format the date as "YYYY-MM-DD" and add it to the array
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledMondays.push(formattedDate);
        }
        // Move to the next day
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledMondays;
    }

    function getDisabledSundays(year) {
      var disabledSundays = [];
      var currentDate = new Date(year, 0, 1);
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Sunday (Sunday corresponds to day 0)
        if (currentDate.getDay() === 1) {
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledSundays.push(formattedDate);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledSundays;
    }

    function getDisabledWeekends(year) {
      var disabledWeekends = [];
      var currentDate = new Date(year, 0, 1);
      while (currentDate.getFullYear() === year) {
        // Check if the current day is a Saturday (Saturday corresponds to day 0) or Sunday (Sunday corresponds to day 1)
        if (currentDate.getDay() === 0 || currentDate.getDay() === 1) {
          var formattedDate = currentDate.toISOString().split("T")[0];
          disabledWeekends.push(formattedDate);
        }
        currentDate.setDate(currentDate.getDate() + 1);
      }
      return disabledWeekends;
    }

    function updateDatepicker() {
      dateInput.datepicker("destroy"); // Destroy the existing Datepicker instance
      dateInput.datepicker({
        beforeShowDay: function (date) {
          var string = $.datepicker.formatDate("yy-mm-dd", date);
          return [disabledDates.indexOf(string) == -1];
        },
      });

      dateInput.datepicker("option", {
        minDate: new Date(new Date().setDate(new Date().getDate() + 3)),
        dateFormat: "yy-mm-dd",
      });
    }

    jQuery(
      "#expo-option-6133282e-377f-4296-8aa2-d591b1651fb1 , #expo-option-2d490f2f-7f45-49b2-9060-2c3a7ce47311, #expo-option-5141ea06-d3f8-4efa-b36c-8ce964033d46"
    ).on("change", function () {
      var selectedValue = jQuery(this).val();
      // Update the disabledDates array based on the selected value
      if (selectedValue === "Newtown (Closed Monday)") {
        disabledDates = getDisabledMondays(currentYear);
      } else if (selectedValue === "Parramatta (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (selectedValue === "Sydney City (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (selectedValue === "Wynyard (Closed Sunday)") {
        disabledDates = getDisabledSundays(currentYear);
      } else if (
        selectedValue === "Quay Quarter Lanes (Closed Saturday & Sunday)"
      ) {
        disabledDates = getDisabledWeekends(currentYear);
      } else {
        disabledDates = [];
      }
      // Reinitialize the Datepicker with the updated dates
      updateDatepicker();
    });
  }

  //For adding class (CSS perpose)
  if (jQuery("body").hasClass("template-")) {
    jQuery("body").addClass("gbb-app");
  }

  // var d = new Date(Date.now()+259200);
  // var month = d.getMonth()+1;
  // var day = d.getDate();
  // var output = d.getFullYear() + '-' + (month<10 ? '0' : '') + month + '-' + (day<10 ? '0' : '') + day;
  // jQuery(".template-Product #expo-option-b9e4c76a-4c56-4a49-a0d5-843898d0d1a4").attr('min',output);

  // High tea page Booking form js
  jQuery("#book-product").click(function () {
    var qty = jQuery("#qty").val();
    var location = jQuery("#ContactForm-Location").val();
    var date = jQuery("#form-date").val();
    var time = jQuery("#time").val();
    var msg = jQuery("#msg").val();
    if (qty == "") {
      jQuery(".error-qty").show();
      jQuery("#qty").addClass("input--error");
      jQuery(".error-qty").text("Select number of people");
    } else {
      jQuery(".error-qty").hide();
      jQuery("#qty").removeClass("input--error");
    }

    if (date == "") {
      jQuery(".error-date").show();
      jQuery("#form-date").addClass("input--error");
      jQuery(".error-date").text("Please select Date");
    } else {
      jQuery(".error-date").hide();
      jQuery("#form-date").removeClass("input--error");
    }

    if (time == "") {
      jQuery(".high-time").show();
      jQuery("#time").addClass("input--error");
      jQuery(".high-time").text("Please select Time");
    } else {
      jQuery(".high-time").hide();
      jQuery("#time").removeClass("input--error");
    }

    if (msg == "") {
      jQuery(".error-msg").show();
      jQuery("#msg").addClass("input--error");
      jQuery(".error-msg").text("Please enter Message");
    } else {
      jQuery(".error-msg").hide();
      jQuery("#msg").removeClass("input--error");
    }

    if (qty == "" || date == "" || time == "" || msg == "") {
      jQuery(".error-all").show();
      jQuery(".error-all").text(
        "One or more fields have an error. Please check and try again."
      );
      jQuery(".form-message.form-message--success").hide();
      return false;
    } else {
      jQuery(".error-all").hide();
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: qty,
          id: "46644658536767",
          properties: {
            Location: location,
            Date: date,
            Time: time,
            Message: msg,
          },
        },
        dataType: "json",
        success: function (data) {
          console.log(data);
        },
      });
    }
  });

  //customor review star JS
  jQuery(".number-container").each(function () {
    var num = jQuery(this).html();
    for (var i = 1; i <= num; i++) {
      jQuery(this)
        .parent()
        .find(".number-stars")
        .append('<span class="stars-val">' + i + "</span>"); // Append numbers
    }
  });

  //quotes description hide/show content
  jQuery(".quotes-description a.readMore").click(function () {
    jQuery(this).parent().find(".desc1").show();
    jQuery(this).parent().find(".readLess").show();
    jQuery(this).parent().find(".desc").hide();
    jQuery(this).parent().find(".readMore").hide();
  });
  jQuery(".quotes-description a.readLess").click(function () {
    jQuery(this).parent().find(".desc").show();
    jQuery(this).parent().find(".readMore").show();
    jQuery(this).parent().find(".desc1").hide();
    jQuery(this).parent().find(".readLess").hide();
  });

  //For add has-focus class in search feild
  var search = jQuery(".template-Search .search__input").val();
  if (search != "") {
    jQuery(".search__input").parent().addClass("has-focus");
  } else {
    jQuery(".search__input").parent().removeClass("has-focus");
  }

  // var search1 = jQuery("#form-date").val();
  // if (search1 != "") {
  //   jQuery("#form-date").parent().addClass("date_focus");
  // } else {
  //   jQuery("#form-date").parent().removeClass("date_focus");
  // }

  //FEATURED GIFTING PRODUCTS Slider
  jQuery(".product-grid")
    .not(".slick-initialized")
    .slick({
      rows: 2,
      dots: false,
      arrows: true,
      infinite: true,
      speed: 300,
      slidesToShow: 5,
      slidesToScroll: 1,
      loop: true,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 768,
          rows: 1,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          rows: 1,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

  //FEATURED GIFTING PRODUCTS Slider for Mobile version
  if (jQuery(window).width() < 768) {
    jQuery(".product-grid")
      .not(".slick-initialized")
      .slick({
        rows: 2,
        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 5,
        slidesToScroll: 1,
        loop: true,
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 2,
              adaptiveHeight: true,
            },
          },
          {
            breakpoint: 768,
            rows: 1,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            rows: 1,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  }

  //on collection page add product into cart with add to cart btn
  jQuery(".add-to-cuscart-button").click(function () {
    jQuery(".view-cart").hide();
    var that = jQuery(this);
    console.log(that);
    var view = jQuery(".apart-img").closest(".view-cart");
    var data = {
      id: $(this).attr("data-id"),
      quantity: 1,
    };
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (data) {
        $.ajax({
          type: "GET",
          dataType: "json",
          url: "/cart.json",
          success: function (cart) {
            $("#cart-icon-bubble span").html(cart.item_count);
            that.parent().find(".view-cart").show();
          },
        });
      },
    });
  });

  $(".acc").click(function () {
    $(".acc").removeClass("active");
    $(this).addClass("active");
  });

  //Add js for active class when redirect to Privacy and Security
  if (jQuery("body").hasClass("template-PagePrivacyAndSecurity")) {
    jQuery(".footer-pages .privacy-security a").addClass(
      "header__active-menu-item"
    );
  }

  //Add js for active class when redirect to Terms and Condition
  if (jQuery("body").hasClass("template-PageTermsAndConditions")) {
    jQuery(".footer-pages .terms-condition a").addClass(
      "header__active-menu-item"
    );
  }

  //Adding class for CSS
  if (jQuery("body").hasClass("template-CustomersOrder")) {
    jQuery("body").addClass("template-CustomersAccount");
  }

  //===========forgot breadcrumbs js
  jQuery("#RecoverPassword").on("click", function () {
    jQuery("body").addClass("forgot_pass_page");
    if (jQuery("body").hasClass("forgot_pass_page")) {
      jQuery(".login-text").html("Reset Account Password");
    }
  });
  jQuery("#HideRecoverPasswordLink").on("click", function () {
    jQuery("body").addClass("forgot_pass_page");
    if (jQuery("body").hasClass("forgot_pass_page")) {
      jQuery(".login-text").html("Login");
    }
  });

  $(".slider-mobile-gutter .slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: ".slider-nav",
  });
  $(".slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  });

  //Adding Js for quotos
  jQuery(".quotes-wrapper")
    .not(".slick-initialized")
    .slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      // autoplay: true,
      dots: true,
      autoplaySpeed: 2000,
      loop: true,
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });

  //For Scroll and sticky header
  jQuery(window).scroll(function () {
    var sticky = jQuery("body"),
      scroll = jQuery(window).scrollTop();
    //console.log(scroll);

    if (scroll >= 100 || (scroll >= 5 && scroll <= 99)) {
      sticky.addClass("sticky_header");
    } else {
      sticky.removeClass("sticky_header");
    }
  });

  //For Has focus field
  jQuery("input, select, textarea,email,password,tel").each(function (index) {
    var input = jQuery(this);

    input.on("focus", function () {
      jQuery(this).parent().addClass("has-focus");
    });

    if (!input.hasClass("hasDatepicker")) {
      input.on("focusout", function () {
        if (jQuery(this).val() == "") {
          jQuery(this).parent().removeClass("has-focus");
        }
      });
    }
  });

  jQuery("input, select, textarea,email,password,tel").each(function (index) {
    var input = jQuery(this);

    if (jQuery(this).val() != "") {
      jQuery(this).parent().addClass("has-focus");
    }
  });

  //    input.on('focusout', function () {
  //      if (jQuery(this).val() == '') {
  //        jQuery(this).parent().removeClass("has-focus");
  //      }
  //    });
  // });

  //for Fancy Box
  jQuery('[data-fancybox="gallery"]').fancybox({
    buttons: ["slideShow", "thumbs", "zoom", "fullScreen", "share", "close"],
    loop: false,
    protect: true,
  });
  jQuery(".gallery-img").click(function () {
    jQuery("body").addClass("no-scroll");
  });
  jQuery(document).on("click", ".fancybox-close", function () {
    jQuery("body").removeClass("no-scroll");
  });

  //------------------- login-form validation ------------------

  jQuery(".btn_submit").on("click", function () {
    var email = jQuery("#customer_login #CustomerEmail").val();
    var pass = jQuery("#customer_login .input-psswd").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var emailflag = 0,
      passflag = 0;
    if (email == "") {
      jQuery(".error-email-login").show();
      jQuery("#customer_login #CustomerEmail").addClass("input--error");
      jQuery(".error-email-login").text("Please enter your email.");
      emailflag = 1;
      //return false;
    } else {
      if (!test_pattern.test(email)) {
        jQuery(".error-email-login").show();
        jQuery("#customer_login #CustomerEmail").addClass("input--error");
        console.log("test");
        jQuery(".error-email-login").text(
          "The email address entered is invalid."
        );
        emailflag = 1;
        return false;
      } else {
        jQuery(".error-email-login").hide();
        jQuery("#customer_login .input-email").removeClass("input--error");
      }
    }
    if (pass == "") {
      passflag = 1;
      jQuery(".erros-pass-login").show();
      jQuery("#customer_login .input-psswd").addClass("input--error");
      console.log("test1");
      jQuery(".erros-pass-login").text("Please enter your password");
      return false;
    } else {
      jQuery(".erros-pass-login").hide();
      jQuery("#customer_login .input-psswd").removeClass("input--error");
      return true;
    }
    if (email == "" || pass == "") {
      jQuery(".error-all").show();
      jQuery(".error-all").text(
        "One or more fields have an error. Please check and try again."
      );
      jQuery(".form-message.form-message--success").hide();
      return false;
    } else {
      jQuery(".error-all").hide();
      return true;
    }
  });

  jQuery(".top-btn").hide();
  jQuery(window).scroll(function () {
    if (jQuery(this).scrollTop() > 100) {
      jQuery(".top-btn").fadeIn("slow");
    } else {
      jQuery(".top-btn").fadeOut("slow");
    }
  });
  jQuery(".top-btn ").click(function () {
    jQuery("html, body").animate({ scrollTop: 0 }, 1200);
    return false;
  });

  jQuery(".contact_submit_btn").on("click", function () {
    var name = jQuery("#ContactForm-name").val();
    var email = jQuery("#ContactForm-email").val();
    var lname = jQuery("#ContactForm-Lastname").val();
    var msg = jQuery("#ContactForm-body").val();
    var phone = jQuery("#ContactForm-phone").val();
    var subject = jQuery("#subject").val();
    var flag = 0;
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;

    if (name == "") {
      jQuery(".input-name").show();
      jQuery("#ContactForm-name").addClass("input--error");
      jQuery(".input-name").text("Please enter your name.");
      flag = 1;
    } else {
      jQuery(".input-name").hide();
      jQuery("#ContactForm-name").removeClass("input--error");
    }
    if (email == "") {
      jQuery(".input-email").show();
      jQuery("#ContactForm-email").addClass("input--error");
      jQuery(".input-email").text("Please enter an email address.");
      flag = 1;
    } else {
      if (!test_pattern.test(email)) {
        flag = 1;
        jQuery(".input-email").show();
        jQuery("#ContactForm-email").addClass("input--error");
        jQuery(".input-email").text("Please enter valid email address.");
      } else {
        jQuery(".input-email").hide();
        jQuery("#ContactForm-email").removeClass("input--error");
      }
    }

    if (phone == "") {
      jQuery(".input-phone").show();
      jQuery("#ContactForm-phone").addClass("input--error");
      jQuery(".input-phone").text("Please enter your contact number.");
      flag = 1;
    } else {
      jQuery(".input-phone").hide();
      jQuery("#ContactForm-phone").removeClass("input--error");
    }

    if (subject == "") {
      jQuery(".error-subject").show();
      jQuery("#subject").addClass("input--error");
      jQuery(".error-subject").text("Please enter your Subject.");
      flag = 1;
    } else {
      jQuery(".error-subject").hide();
      jQuery("#subject").removeClass("input--error");
    }

    if (msg == "") {
      jQuery(".input-msg").show();
      jQuery("#ContactForm-body").addClass("input--error");
      jQuery(".input-msg").text("Please enter your message.");
      flag = 1;
    } else {
      jQuery(".input-msg").hide();
      jQuery("#ContactForm-body").removeClass("input--error");
    }

    if (flag == 1) {
      jQuery(".error-all").show();
      jQuery(".error-all").text(
        "One or more fields have an error. Please check and try again."
      );
      jQuery(".form-message.form-message--success").hide();
      return false;
    } else {
      jQuery(".error-all").hide();
      return true;
    }
  });

  jQuery(".search__button").click(function () {
    var ogSearch = jQuery(".og-search").val();

    if (ogSearch == "") {
      jQuery(".search-error").show();
      jQuery(".og-search").addClass("input--error");
      jQuery(".search-error").text("Please fill the blank.");
    } else {
      jQuery(".search-error").hide();
      jQuery(".og-search").removeClass("input--error");
    }
  });

  //........customer register........//

  jQuery(".template-CustomersRegister .reg_btn").on("click", function (e) {
    var fname = jQuery("#create_customer #RegisterForm-FirstName").val();
    var lname = jQuery("#create_customer .RegisterForm-LastName").val();
    var email = jQuery("#create_customer #RegisterForm-email").val();
    var password = jQuery("#create_customer .input-psswd").val();
    var confirePassword = jQuery(
      "#create_customer .CreateconfirmPassword"
    ).val();
    //console.log(confirePassword);
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    //var flag = 0;
    var con_passwd_err = 0;
    if (
      fname == "" ||
      lname == "" ||
      email == "" ||
      password == "" ||
      confirePassword == ""
    ) {
      console.log("error");
      jQuery(".error-all-msg").show();
      jQuery(".error-all-msg").text(
        "One or more fields have an error. Please check and try again."
      );
      e.preventDefault();
    } else {
      jQuery(".success-msg").show();
      jQuery(".success-msg").text(
        "Thank you for your message, we will be in contact with you shortly."
      );

      jQuery(".error-all-msg").hide();
      return true;
      //e.preventDefault();
    }
    if (fname == "") {
      jQuery("#create_customer #RegisterForm-FirstName").addClass(
        "input--error"
      );
      jQuery(".error-fname").show();
      jQuery(".error-fname").text("Please enter your first name.");
      e.preventDefault();
    } else {
      jQuery("#create_customer #RegisterForm-FirstName").removeClass(
        "input--error"
      );
      jQuery(".error-fname").hide();
    }
    if (lname == "") {
      jQuery(".error-lname").show();
      jQuery("#create_customer .RegisterForm-LastName").addClass(
        "input--error"
      );
      jQuery(".error-lname").text("Please enter your last name.");
      e.preventDefault();
    } else {
      jQuery(".error-lname").hide();
      jQuery("#create_customer .RegisterForm-LastName").removeClass(
        "input--error"
      );
    }
    if (email == "") {
      jQuery(".error-email").show();
      jQuery("#create_customer #RegisterForm-email").addClass("input--error");
      jQuery(".error-email").text("Please enter your email.");
      e.preventDefault();
    } else {
      if (!test_pattern.test(email)) {
        jQuery(".error-email").show();
        jQuery("#create_customer #RegisterForm-email").addClass("input--error");
        jQuery(".error-email").text("The email address entered is invalid.");
        e.preventDefault();
      } else {
        jQuery(".error-email").hide();
        jQuery("#create_customer #RegisterForm-email").removeClass(
          "input--error"
        );
      }
    }
    if (password == "") {
      jQuery(".pass-error").show();
      jQuery("#create_customer .input-psswd").addClass("input--error");
      jQuery(".pass-error").text("Please enter your password.");
      e.preventDefault();
    } else {
      jQuery("#create_customer .input-psswd").removeClass("input--error");
      jQuery(".pass-error").hide();
    }
    if (confirePassword == "") {
      jQuery(".confo-pass-error").show();
      jQuery("#create_customer .CreateconfirmPassword").addClass(
        "input--error"
      );
      jQuery(".confo-pass-error").text("Please enter your Conform password.");
      e.preventDefault();
    } else if (password != confirePassword) {
      jQuery(".confo-pass-error").show();
      jQuery("#create_customer .CreateconfirmPassword").addClass(
        "input--error"
      );
      jQuery(".confo-pass-error").text("Please enter your right password.");
      e.preventDefault();
    } else {
      jQuery("#create_customer .CreateconfirmPassword").removeClass(
        "input--error"
      );
      jQuery(".confo-pass-error").hide();
    }
  });

  //...................................forgot pwd js...................................//
  var url_reset = window.location.href;
  url_reset = url_reset.split("#");
  console.log(url_reset);
  url_reset = url_reset[url_reset.length - 1];
  if (url_reset == "recover") {
    jQuery(".login-text").html("Forgot Your Password?");
  }

  jQuery(".recover_btn").on("click", function (e) {
    var email = jQuery("#RecoverEmail").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var flag = 0;
    jQuery(".error-all").hide();

    if (email == "") {
      flag = 1;
      jQuery(".error-email").show();
      jQuery("#RecoverEmail").addClass("input--error");
      jQuery(".error-email").text("Please enter your email.");
      return false;
    } else {
      if (!test_pattern.test(email)) {
        jQuery(".error-email").show();
        jQuery("#RecoverEmail").addClass("input--error");
        jQuery(".error-email").text("The email address entered is invalid.");
        flag = 1;
      } else {
        jQuery(".error-email").hide();
        jQuery("#RecoverEmail").removeClass("input--error");
      }
    }
    if (flag == 1) {
      return false;
    } else {
      return true;
    }
  });

  //For add address
  jQuery(".btn-add-addresses").on("click", function () {
    var fname = jQuery("#AddressFirstNameNew").val();
    var lname = jQuery("#AddressLastNameNew").val();
    var add = jQuery("#AddressAddress1New").val();
    var add2 = jQuery("#AddressAddress2New").val();
    var city = jQuery("#AddressCityNew").val();
    var country = jQuery("#AddressCountryNew").val();
    var zip = jQuery("#AddressZipNew").val();
    var phone = jQuery("#AddressPhoneNew").val();
    var company = jQuery("#AddressCompanyNew").val();

    var fflag = 0,
      lflag = 0,
      addflag = 0,
      add2flag = 0,
      cityflag = 0,
      countryflag = 0,
      zipflag = 0,
      phoneflag = 0,
      companyflag = 0;

    if (fname == "") {
      jQuery(".error-fname").show();
      jQuery("#AddressFirstNameNew").addClass("input--error");
      jQuery(".error-fname").text("Please enter your first name.");
      fflag = 1;
    } else {
      jQuery(".error-fname").hide();
      jQuery("#AddressFirstNameNew").removeClass("input--error");
    }
    if (lname == "") {
      jQuery(".error-lname").show();
      jQuery("#AddressLastNameNew").addClass("input--error");
      jQuery(".error-lname").text("Please enter your last name.");
      lflag = 1;
    } else {
      jQuery(".error-lname").hide();
      jQuery("#AddressLirstNameNew").removeClass("input--error");
    }
    if (add == "") {
      jQuery(".error-add1").show();
      jQuery("#AddressAddress1New").addClass("input--error");
      jQuery(".error-add1").text("Please enter your address.");
      addflag = 1;
    } else {
      jQuery(".error-add1").hide();
      jQuery("#AddressAddress1New").removeClass("input--error");
    }

    if (add2 == "") {
      jQuery(".error-add2").show();
      jQuery("#AddressAddress2New").addClass("input--error");
      jQuery(".error-add2").text("Please enter your address.");
      add2flag = 1;
    } else {
      jQuery(".error-add2").hide();
      jQuery("#AddressAddress2New").removeClass("input--error");
    }
    if (city == "") {
      jQuery(".error-city").show();
      jQuery("#AddressCityNew").addClass("input--error");
      jQuery(".error-city").text("Please enter your city.");
      cityflag = 1;
    } else {
      jQuery(".error-city").hide();
      jQuery("#AddressCityNew").removeClass("input--error");
    }
    if (zip == "") {
      jQuery(".error-zip").show();
      jQuery("#AddressZipNew").addClass("input--error");
      jQuery(".error-zip").text("Please enter your zip code.");
      zipflag = 1;
    } else {
      jQuery(".error-zip").hide();
      jQuery("#AddressZipNew").removeClass("input--error");
    }

    if (phone == "") {
      jQuery(".error-phone").show();
      jQuery("#AddressPhoneNew").addClass("input--error");
      jQuery(".error-phone").text("Please enter your phone number.");
      phoneflag = 1;
    } else {
      jQuery(".error-phone").hide();
      jQuery("#AddressPhoneNew").removeClass("input--error");
    }
    if (company == "") {
      jQuery(".error-company").show();
      jQuery("#AddressCompanyNew").addClass("input--error");
      jQuery(".error-company").text("Please enter your company.");
      companyflag = 1;
    } else {
      jQuery(".error-company").hide();
      jQuery("#AddressCompanyNew").removeClass("input--error");
    }

    if (
      fflag == 1 ||
      lflag == 1 ||
      addflag == 1 ||
      add2flag == 1 ||
      cityflag == 1 ||
      zipflag == 1 ||
      phoneflag == 1 ||
      companyflag == 1
    ) {
      jQuery(".error-all").show();
      jQuery(".error-all").html(
        "One or more fields have an error. Please check and try again."
      );
      return false;
    } else {
      jQuery(".error-all").hide();
      return true;
    }
  });

  //add cancel address
  jQuery(".add-cancle-address-form").on("click", function () {
    jQuery(".error-all").hide();
    jQuery("#AddressPhoneNew").removeClass("input--error");
    jQuery(".error-phone").hide();
    jQuery("#AddressZipNew").removeClass("input--error");
    jQuery(".error-zip").hide();
    jQuery("#AddressCityNew").removeClass("input--error");
    jQuery(".error-city").hide();
    jQuery("#AddressAddress2New").removeClass("input--error");
    jQuery(".error-add2").hide();
    jQuery("#AddressAddress1New").removeClass("input--error");
    jQuery(".error-add1").hide();
    jQuery("#AddressCompanyNew").removeClass("input--error");
    jQuery(".error-company").hide();
    jQuery("#AddressLastNameNew").removeClass("input--error");
    jQuery(".error-lname").hide();
    jQuery("#AddressFirstNameNew").removeClass("input--error");
    jQuery(".error-fname").hide();
  });

  //-------------------- Reset password form validation ------------------//

  jQuery(".reset_btn").on("click", function (e) {
    var res_passwd = jQuery(".input-psswd").val();
    var con_passwd = jQuery(".input-con-psswd").val();
    var res_passwd_err = 0;
    var con_passwd_err = 0;
    if (res_passwd.trim() == "") {
      jQuery(".error-pass").show();
      res_passwd_err = 1;
      jQuery(".input-psswd").addClass("input--error");
      jQuery(".error-pass").text("Please enter your password.");
      e.preventDefault();
    } else {
      res_passwd_err = 0;
      jQuery(".error-pass").hide();
      jQuery(".input-psswd").removeClass("input--error");
    }

    if (con_passwd.trim() == "") {
      con_passwd_err = 1;
      jQuery(".confirm-pass-error").show();
      jQuery(".template-CustomersResetPassword .input-con-psswd").addClass(
        "input--error"
      );
      jQuery(".confirm-pass-error").text(
        "Please enter your confirmation password."
      );
      e.preventDefault();
    } else if (res_passwd != con_passwd) {
      con_passwd_err = 2;
      jQuery("#ResetPassword").addClass("input--error");
      jQuery(".template-CustomersResetPassword .input-con-psswd").addClass(
        "input--error"
      );
      jQuery(".confirm-pass-error").text("Please enter your right password.");
      e.preventDefault();
    } else {
      con_passwd_err = 0;
      jQuery("#ResetPassword").removeClass("input--error");
      jQuery(".template-customers-reset_password .input-con-psswd").removeClass(
        "input--error"
      );
      jQuery(".confirm-pass-error").hide();
    }

    if (res_passwd_err == 1 || con_passwd_err == 1) {
      jQuery(".reset-error-all").show();
      jQuery(".reset-error-all").text(
        "One or more fields have an error. Please check and try again."
      );
      return false;
      e.preventDefault();
    } else {
      if (con_passwd_err == 2) {
        jQuery(".reset-error-all").text(
          "Password and confirmation password does not match."
        );
        jQuery(".reset-error-all").show();
        return false;
        e.preventDefault();
      } else {
        jQuery(".reset-error-all").hide();
        return true;
      }
    }
  });

  if (jQuery("body").hasClass("template-CustomersOrder")) {
    jQuery("body").addClass("template-CustomersAccount");
  }

  //
  jQuery(".high-tea-btn").click(function () {
    var name = jQuery("#ContactForm-name").val();
    var email = jQuery("#ContactForm-email").val();
    var phone = jQuery("#ContactForm-phone").val();
    var store = jQuery("#ContactForm-store").val();
    var time = jQuery("#ContactForm-time").val();
    var people = jQuery("#ContactForm-nop").val();
    var message = jQuery("#ContactForm-msg").val();
    var test_pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    var flag = 0;

    if (name == "") {
      jQuery(".high-name").show();
      jQuery("#ContactForm-name").addClass("input--error");
      jQuery(".high-name").text("Please enter your name.");
      flag = 1;
      return false;
    } else {
      jQuery(".high-name").hide();
      jQuery("#ContactForm-name").removeClass("input--error");
      return true;
    }

    if (email == "") {
      jQuery(".high-email").show();
      jQuery("#ContactForm-email").addClass("input--error");
      jQuery(".high-email").text("Please enter an email address.");
      flag = 1;
      //return false;
    } else {
      if (!test_pattern.test(email)) {
        flag = 1;
        jQuery(".high-email").show();
        jQuery("#ContactForm-email").addClass("input--error");
        jQuery(".high-email").text("Please enter valid email address.");
        //return false;
      } else {
        jQuery(".high-email").hide();
        jQuery("#ContactForm-email").removeClass("input--error");
        //return true;
      }
      return true;
    }

    if (phone == "") {
      jQuery(".high-phone").show();
      jQuery("#ContactForm-phone").addClass("input--error");
      jQuery(".high-phone").text("Please enter your name.");
      flag = 1;
      return false;
    } else {
      jQuery(".high-phone").hide();
      jQuery("#ContactForm-phone").removeClass("input--error");
      return true;
    }

    if (store == "") {
      jQuery(".high-store").show();
      jQuery("#ContactForm-store").addClass("input--error");
      jQuery(".high-store").text("Please enter your Store.");
      flag = 1;
      return false;
    } else {
      jQuery(".high-store").hide();
      jQuery("#ContactForm-store").removeClass("input--error");
      return true;
    }

    if (time == "") {
      jQuery(".high-time").show();
      jQuery("#ContactForm-time").addClass("input--error");
      jQuery(".high-time").text("Please enter your Time.");
      flag = 1;
      return false;
    } else {
      jQuery(".high-time").hide();
      jQuery("#ContactForm-time").removeClass("input--error");
      return true;
    }

    if (people == "") {
      jQuery(".high-nop").show();
      jQuery("#ContactForm-nop").addClass("input--error");
      jQuery(".high-nop").text("Please enter your No of people.");
      flag = 1;
      return false;
    } else {
      jQuery(".high-nop").hide();
      jQuery("#ContactForm-nop").removeClass("input--error");
      return true;
    }

    if (msg == "") {
      jQuery(".high-msg").show();
      jQuery("#ContactForm-msg").addClass("input--error");
      jQuery(".high-msg").text("Please enter your message.");
      flag = 1;
      return false;
    } else {
      jQuery(".high-msg").hide();
      jQuery("#ContactForm-msg").removeClass("input--error");
      return true;
    }

    if (flag == 1) {
      jQuery(".high-all").show();
      jQuery(".high-all").text(
        "One or more fields have an error. Please check and try again."
      );
      jQuery(".form-message.form-message--success").hide();
      return false;
    } else {
      jQuery(".high-all").hide();
      return true;
    }
  });

  //menu open close on mouse hover
  jQuery(".header__inline-menu > ul > li > header-menu > details")
    .on("mouseover", function () {
      jQuery(this).attr("open", true);
      jQuery(this).find("summary").attr("aria-expanded", "true");
    })
    .mouseleave(function () {
      jQuery(this).removeAttr("open");
      jQuery(this).find("summary").attr("aria-expanded", "false");
    });

  // setTimeout(function() {
  //   jQuery('.wholesaler-form').click(function(e) {
  //       //e.preventDefault();
  //       var cLegalName = jQuery('#ContactForm-name').val();
  //       var cBillingAdd = jQuery('#ContactForm-billing').val();
  //       var cEmail = jQuery('#ContactForm-email').val();
  //       var cPhone = jQuery('#ContactForm-phone').val();
  //       var cFax = jQuery('#ContactForm-fax').val();
  //       var cMobile = jQuery('#ContactForm-mobile').val();
  //       var pDate = jQuery('#ContactForm-date').val();
  //       var pLicence = jQuery('#ContactForm-licence').val();
  //       var bTrading = jQuery('#ContactForm-trading').val();
  //       var bABN = jQuery('#ContactForm-abn').val();
  //       var bACN = jQuery('#ContactForm-acn').val();
  //       var bContact = jQuery('#ContactForm-busContact').val();
  //       var bPhone = jQuery('#ContactForm-busPhone').val();
  //       var bNatureBUsiness = jQuery('#ContactForm-nob').val();
  //       var oName = jQuery('#ContactForm-ownersName').val();
  //       var oDOB = jQuery('#ContactForm-dob').val();
  //       var oAddress = jQuery('#ContactForm-ownerAddress').val();
  //       var oLicence = jQuery('#ContactForm-owner-licence').val();
  //       var oPhone = jQuery('#ContactForm-ownersPhone').val();
  //       var oMobile = jQuery('#ContactForm-ownersMobile').val();
  //       var oNameS = jQuery('#ContactForm-ownersName2').val();
  //       var oDOBS = jQuery('#ContactForm-dob2').val();
  //       var oAddressS = jQuery('#ContactForm-ownerAddress2').val();
  //       var oLicenceS = jQuery('#ContactForm-owner-licence2').val();
  //       var oPhoneS = jQuery('#ContactForm-ownersPhone2').val();
  //       var oMobileS = jQuery('#ContactForm-ownersMobile2').val();

  //       if (cLegalName == "") {
  //           jQuery('.error-name').show();
  //           jQuery('#ContactForm-name').addClass('input--error');
  //           jQuery('.error-name').text('Please enter your name.');
  //           //e.preventDefault();
  //           return false;

  //       } else {
  //           jQuery('.error-name').hide();
  //           jQuery('#ContactForm-name').removeClass('input--error');
  //           return true;
  //       }

  //       var physicalAdd = jQuery('#ContactForm-address').val();
  //       if ( physicalAdd == '') {
  //           jQuery('.input-error-address').show();
  //           jQuery('#ContactForm-address').addClass('input--error');
  //           jQuery('.input-error-address').text('Please enter your Physical Address.');
  //           //e.preventDefault();
  //           //return false;
  //       } else {
  //           jQuery('.input-error-address').hide();
  //           jQuery('#ContactForm-address').removeClass('input--error');
  //           //return true;
  //       }

  //       if (cBillingAdd == "") {
  //           jQuery('.error-billing').show();
  //           jQuery('#ContactForm-billing').addClass('input--error');
  //           jQuery('.error-billing').text('Please enter Billing Address.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-billing').hide();
  //           jQuery('#ContactForm-billing').removeClass('input--error');
  //           return true;
  //       }

  //       if (cEmail == "") {
  //           jQuery('.error-email').show();
  //           jQuery('#ContactForm-email').addClass('input--error');
  //           jQuery('.error-email').text('Please enter an email address.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           if (!test_pattern.test(cEmail)) {
  //               return false;
  //               jQuery('.error-email').show();
  //               jQuery('#ContactForm-email').addClass('input--error');
  //               jQuery('.error-email').text('Please enter valid email address.');
  //               //e.preventDefault();
  //               return false;
  //           } else {
  //               jQuery('.error-email').hide();
  //               jQuery('#ContactForm-email').removeClass('input--error');
  //               return true;
  //           }

  //       }

  //       if (cPhone == "") {
  //           jQuery('.error-phone').show();
  //           jQuery('#ContactForm-phone').addClass('input--error');
  //           jQuery('.error-phone').text('Please enter Phone No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-phone').hide();
  //           jQuery('#ContactForm-phone').removeClass('input--error');
  //           return true;
  //       }
  //       if (cFax == "") {
  //           jQuery('.error-fax').show();
  //           jQuery('#ContactForm-fax').addClass('input--error');
  //           jQuery('.error-fax').text('Please enter Fax No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-fax').hide();
  //           jQuery('#ContactForm-fax').removeClass('input--error');
  //           return true;
  //       }
  //       if (cMobile == "") {
  //           jQuery('.error-mobile').show();
  //           jQuery('#ContactForm-mobile').addClass('input--error');
  //           jQuery('.error-mobile').text('Please enter Mobile No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-mobile').hide();
  //           jQuery('#ContactForm-mobile').removeClass('input--error');
  //           return true;
  //       }

  //       if (pDate == "") {
  //           jQuery('.error-date').show();
  //           jQuery('#ContactForm-date').addClass('input--error');
  //           jQuery('.error-date').text('Please Select date.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-date').hide();
  //           jQuery('#ContactForm-date').removeClass('input--error');
  //           return true;
  //       }
  //       if (pLicence == "") {
  //           jQuery('.error-licence').show();
  //           jQuery('#ContactForm-licence').addClass('input--error');
  //           jQuery('.error-licence').text('Please enter Licence No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-licence').hide();
  //           jQuery('#ContactForm-licence').removeClass('input--error');
  //           return true;
  //       }

  //       if (bTrading == "") {
  //           jQuery('.error-trading').show();
  //           jQuery('#ContactForm-trading').addClass('input--error');
  //           jQuery('.error-trading').text('Please enter Trading Name.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-trading').hide();
  //           jQuery('#ContactForm-trading').removeClass('input--error');
  //           return true;
  //       }
  //       if (pABN == "") {
  //           jQuery('.error-abn').show();
  //           jQuery('#ContactForm-abn').addClass('input--error');
  //           jQuery('.error-abn').text('Please enter ABN.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-abn').hide();
  //           jQuery('#ContactForm-abn').removeClass('input--error');
  //           return true;
  //       }
  //       if (pACN == "") {
  //           jQuery('.error-acn').show();
  //           jQuery('#ContactForm-acn').addClass('input--error');
  //           jQuery('.error-acn').text('Please enter ACN No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-acn').hide();
  //           jQuery('#ContactForm-acn').removeClass('input--error');
  //           return true;
  //       }
  //       if (bContact == "") {
  //           jQuery('.error-contact').show();
  //           jQuery('#ContactForm-contact').addClass('input--error');
  //           jQuery('.error-contact').text('Please enter Contact No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-contact').hide();
  //           jQuery('#ContactForm-contact').removeClass('input--error');
  //           return true;
  //       }
  //       if (bPhone == "") {
  //           jQuery('.error-phone').show();
  //           jQuery('#ContactForm-phone').addClass('input--error');
  //           jQuery('.error-phone').text('Please enter Phone No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-phone').hide();
  //           jQuery('#ContactForm-phone').removeClass('input--error');
  //           return true;
  //       }
  //       if (bNatureBUsiness == "") {
  //           jQuery('.error-nob').show();
  //           jQuery('#ContactForm-nob').addClass('input--error');
  //           jQuery('.error-nob').text('Please enter Nature Of Business.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-nob').hide();
  //           jQuery('#ContactForm-nob').removeClass('input--error');
  //           return true;
  //       }

  //       if (oName == "") {
  //           jQuery('.error-ownersName').show();
  //           jQuery('#ContactForm-ownersName').addClass('input--error');
  //           jQuery('.error-ownersName').text('Please enter (01)Full Name.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-ownersName').hide();
  //           jQuery('#ContactForm-ownersName').removeClass('input--error');
  //           return true;
  //       }
  //       if (oDOB == "") {
  //           jQuery('.error-dob').show();
  //           jQuery('#ContactForm-dob').addClass('input--error');
  //           jQuery('.error-dob').text('Please Select date Of Birth.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-dob').hide();
  //           jQuery('#ContactForm-dob').removeClass('input--error');
  //           return true;
  //       }
  //       if (oAddress == "") {
  //           jQuery('.error-ownerAddress').show();
  //           jQuery('#ContactForm-ownerAddress').addClass('input--error');
  //           jQuery('.error-ownerAddress').text('Please enter Physical Address.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-ownerAddress').hide();
  //           jQuery('#ContactForm-ownerAddress').removeClass('input--error');
  //           return true;
  //       }
  //       if (oLicence == "") {
  //           jQuery('.error-owner-licence').show();
  //           jQuery('#ContactForm-contact').addClass('input--error');
  //           jQuery('.error-owner-licence').text('Please enter Driver Licence No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-owner-licence').hide();
  //           jQuery('#ContactForm-owner-licence').removeClass('input--error');
  //           return true;
  //       }
  //       if (oPhone == "") {
  //           jQuery('.error-ownersPhone').show();
  //           jQuery('#ContactForm-ownersPhone').addClass('input--error');
  //           jQuery('.error-ownersPhone').text('Please enter Phone No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-ownersPhone').hide();
  //           jQuery('#ContactForm-ownersPhone').removeClass('input--error');
  //           return true;
  //       }
  //       if (oMobile == "") {
  //           jQuery('.error-ownersMobile').show();
  //           jQuery('#ContactForm-ownersMobile').addClass('input--error');
  //           jQuery('.error-ownersMobile').text('Please enter Mobile No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-ownersMobile').hide();
  //           jQuery('#ContactForm-ownersMobile').removeClass('input--error');
  //           return true;
  //       }

  //       if (oNameS == "") {
  //           jQuery('.error-ownersName2').show();
  //           jQuery('#ContactForm-ownersName2').addClass('input--error');
  //           jQuery('.error-ownersName2').text('Please enter (02)Full Name.');
  //           //e.preventDefault();
  //           return false;

  //       } else {
  //           jQuery('.error-ownersName2').hide();
  //           jQuery('#ContactForm-ownersName2').removeClass('input--error');
  //           return true;
  //       }
  //       if (oDOBS == "") {
  //           jQuery('.error-dob2').show();
  //           jQuery('#ContactForm-dob2').addClass('input--error');
  //           jQuery('.error-dob2').text('Please Select date Of Birth.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-dob2').hide();
  //           jQuery('#ContactForm-dob2').removeClass('input--error');
  //           return true;
  //       }
  //       if (oAddressS == "") {
  //           jQuery('.error-ownerAddress2').show();
  //           jQuery('#ContactForm-ownerAddress2').addClass('input--error');
  //           jQuery('.error-ownerAddress2').text('Please enter Physical Address.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-ownerAddress2').hide();
  //           jQuery('#ContactForm-ownerAddress2').removeClass('input--error');
  //           return true;
  //       }
  //       if (oLicenceS == "") {
  //           jQuery('.error-owner-licence2').show();
  //           jQuery('#ContactForm-contact2').addClass('input--error');
  //           jQuery('.error-owner-licence2').text('Please enter Driver Licence No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-owner-licence2').hide();
  //           jQuery('#ContactForm-owner-licence2').removeClass('input--error');
  //           return true;
  //       }
  //       if (oPhoneS == "") {
  //           jQuery('.error-ownersPhone2').show();
  //           jQuery('#ContactForm-ownersPhone2').addClass('input--error');
  //           jQuery('.error-ownersPhone2').text('Please enter Phone No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-ownersPhone2').hide();
  //           jQuery('#ContactForm-ownersPhone2').removeClass('input--error');
  //           return true;
  //       }
  //       if (oMobileS == "") {
  //           jQuery('.error-ownersMobile2').show();
  //           jQuery('#ContactForm-ownersMobile2').addClass('input--error');
  //           jQuery('.error-ownersMobile2').text('Please enter Mobile No.');
  //           //e.preventDefault();
  //           return false;
  //       } else {
  //           jQuery('.error-ownersMobile2').hide();
  //           jQuery('#ContactForm-ownersMobile2').removeClass('input--error');
  //           return true;
  //       }

  //       if(cLegalName == '' || cPhysicalAdd =='' || cBillingAdd == '' || cEmail == '' || cPhone == '' || cFax == '' || cMobile == '' || pDate == '' || pLicence == '' || bTrading == '' || bABN == '' || bACN == '' || bContact == '' || bPhone == '' || bNatureBUsiness == '' || oName == '' || oDOB == '' || oAddress == '' || oLicence == '' || oPhone == '' || oMobile == '' || oNameS == '' || oDOBS == '' || oAddressS == '' || oLicenceS == '' || oPhoneS == '' || oMobileS == '')
  //       {
  //           jQuery('.error-all').show();
  //           jQuery('.error-all').text('One or more fields have an error. Please check and try again.');
  //           //e.preventDefault();
  //           return false;
  //       }else{
  //           jQuery('error.all').hide();
  //       }
  //   });
  // },500);
});
